/**
 * Controls a slider toggle with two options for the user to increase or decrease font size on a page.
 * Saves the user's choice so they don't have to select their preference each time.
 *
 * Example:
 *
 * .page{data:{controller: "font-size"}}
 *   .switch
 *     .slider
 *     .letter{ data: { action: "click->font-size#makeTextSmaller" } } A
 *     .letter.text-big{ data: { action: "click->font-size#makeTextLarger" } } A
 *   .content{data:{"font-size-target": "body"}}
 *
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["switch", "body"];

  connect() {
    if (localStorage.getItem("user-set-font-size") === "text-big") {
      this.makeTextLarger(false);
    } else {
      this.makeTextSmaller(false);
    }
  }

  makeTextSmaller(slider_transition = true) {
    if (slider_transition) this.addTransitions();
    this.switchTarget.classList.remove("larger-font-selected");
    this.bodyTarget.classList.remove("text-big", "larger-font-size-body");
    localStorage.setItem("user-set-font-size", "text-medium");
  }

  makeTextLarger(slider_transition = true) {
    if (slider_transition) this.addTransitions();
    this.switchTarget.classList.add("larger-font-selected");
    this.bodyTarget.classList.add("text-big", "larger-font-size-body");
    localStorage.setItem("user-set-font-size", "text-big");
  }

  addTransitions() {
    this.switchTarget.querySelector(".slider").classList.add("slider-transition");
    this.switchTarget.querySelector(".letter").classList.add("letter-transition");
  }
}
